import React from 'react';

import PropTypes from 'prop-types';

import useSize from 'components/hooks/useSize';

import TruncatableText from 'components/application/TruncatableText';

export default function ResizableTruncatableText({ className, text }) {
  const { width: bodyWidth } = useSize(document.body);

  return <TruncatableText className={className} key={bodyWidth} text={text} />;
}

ResizableTruncatableText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};
